function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.899 4.62a.644.644 0 00-.386-.59L8.757 1.092a.647.647 0 00-.514 0L1.487 4.03a.644.644 0 00-.386.59v7.512c0 .26.156.494.396.594l7.067 2.945a.645.645 0 00.515-.008l6.443-2.93a.644.644 0 00.377-.586V4.62zM8.822 7.414L1.22 4.247m7.602 3.167l6.96-3.164M5.403 2.328l7.143 3.396"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.892 8.992a.322.322 0 00-.193-.295L3.482 7.29a.321.321 0 00-.451.295v2.514c0 .128.076.244.193.295l3.217 1.408a.324.324 0 00.451-.296V8.993zm1.93 6.749V7.414"
}));

function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17
  }, props), _ref);
}

export default SvgDelivery;